<link rel="stylesheet" [attr.href]="getWordpressStylesheet()">
<h3 class="header-ext">{{title}}</h3>
<div class="">
    <div [innerHtml]="page | safeHtml" class="inner-cont"></div>
</div>